<script lang="ts">
    import { _ } from "svelte-i18n"
</script>

<section id="desktop-banner" aria-labelledby="contact-info">
    <div class="wrapper">
        <h2 id="contact-info" class="visually-hidden">{$_("header.contact-and-payment-details")}</h2>

        <ul>
            <li>
                <span>{$_("header.hotline")}:</span>
                <a href="tel:+4934315889060" aria-label="Rufen Sie uns unter 03431 588 90 60 an">03431 588 90 60</a>
            </li>
            <li>
                <span>{$_("header.e-mail")}:</span>
                <a href="mailto:info@renz24.de" aria-label="Senden Sie eine E-Mail an info@renz24.de">info@renz24.de</a>
            </li>
        </ul>

        <ul aria-labelledby="payment-and-delivery">
            <h3 id="payment-and-delivery" class="visually-hidden">{$_("header.payment-and-shipment-options")}</h3>
            <li>
                <img style="height: 18px;" src="/media/PaypalGroup.svg" alt="PayPal Logo" />
            </li>
            <li>
                <img style="height: 20px;" src="/media/bill.svg" alt={$_("header.purchase-on-account")} />{$_(
                    "header.purchase-on-account"
                )}
            </li>
            <li>
                <img style="height: 20px;" src="/media/Clock.svg" alt={$_("header.short-delivery-time")} />{$_(
                    "header.short-delivery-time"
                )}
            </li>
            <li>
                <img style="height: 22px;" src="/media/shield-check.svg" alt={$_("header.secure-payment")} />{$_(
                    "header.secure-payment"
                )}
            </li>
        </ul>
    </div>
</section>

<style lang="less">
    @import "../../../../css/variables.less";
    #desktop-banner {
        display: none;
        font-size: 0.9rem;
        justify-content: center;
        background-color: var(--grey-500);
        color: white;
        .wrapper {
            padding: 0.6rem 0px;
            max-width: var(--max-container-width);
            display: flex;
            height: 32px;

            width: 100%;
            justify-content: space-between;
        }
        a {
            color: white;
        }

        padding: 0px var(--default-horizontal-padding);

        ul {
            list-style: none;
            margin: 4px 0px;
            .flex();
            padding: 0px;
            gap: 30px;
            li {
                .flex();
                width: fit-content;
                white-space: nowrap;
                align-items: center;
                gap: 10px;
                img {
                    height: 18px;
                }
            }
        }

        @media (min-width: @res-desktop) {
            .flex();
        }
    }
</style>
